import React from "react";
import { Box, Typography } from "@mui/material";
import { IconifyIcon, InlineIcon } from "@iconify/react";

interface MyHrContractCardItemProps {
  icon: string | IconifyIcon;
  label: string;
}

export const MyHrContractCardItem: React.FC<MyHrContractCardItemProps> = ({
  icon,
  label,
}) => {
  if (!label || label === "N/A" || label === "not_defined") return null;
  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      padding="2px 8px"
    >
      <Box width="20px" height="20px" marginRight="16px">
        <InlineIcon
          icon={icon}
          style={{
            width: "20px",
            height: "20px",
            margin: "0 8px 0 0",
            color: "#212121",
          }}
        />
      </Box>
      <Typography
        variant="body1"
        sx={{
          flex: 1,
          whiteSpace: "normal",
          wordBreak: "break-word",
          overflowWrap: "break-word",
        }}
        title={label}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default MyHrContractCardItem;
